import React from 'react';
import { styled } from '@mui/system';
import { Link } from 'gatsby';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import PhoneIcon from '@mui/icons-material/Phone';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import MenuBookIcon from '@mui/icons-material/MenuBook';

import AnchorLink from 'react-anchor-link-smooth-scroll';

import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const StyledMenu = (props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    sx={{border: '1px solid #d3d4d5'}}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
);

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}));

export default function MainMenu({...props}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleContactSupport = () => {
    handleClose();
    props.onContactSupportClick();
  }

  return (
    <div>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        {Boolean(anchorEl) ? <CloseIcon/> : <MenuIcon/>}
      </Button>
      <StyledMenu
        id="main-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <AnchorLink href='#services' onClick={handleClose} style={{textDecoration: 'none', color: 'inherit'}}>
          <StyledMenuItem>
            <ListItemIcon>
              <BusinessCenterIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Services" />
          </StyledMenuItem>
        </AnchorLink>
        <AnchorLink href='#why-us' onClick={handleClose} style={{textDecoration: 'none', color: 'inherit'}}>
          <StyledMenuItem>
            <ListItemIcon>
              <EmojiPeopleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Why Us" />
          </StyledMenuItem>
        </AnchorLink>
        <AnchorLink href='#media-and-resources' onClick={handleClose} style={{textDecoration: 'none', color: 'inherit'}}>
          <StyledMenuItem>
            <ListItemIcon>
              <VideoLibraryIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Media" />
          </StyledMenuItem>
        </AnchorLink>
        <Link to={"/blog"} style={{color: 'inherit'}}>
          <StyledMenuItem>
            <ListItemIcon>
              <MenuBookIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Blog" />
          </StyledMenuItem>
        </Link>
        <StyledMenuItem onClick={() => handleContactSupport()}>
          <ListItemIcon>
            <PhoneIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Contact Us" />
        </StyledMenuItem>
      </StyledMenu>
    </div>
  );
}
